import UserPrizes from './components/UserPrizes';
export default UserPrizes;